import { map, finalize, catchError, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { RentalObjectDocument } from '../../model/rental-object-document';
import { ConnectedDocumentService } from './connected-document-base.service';

@Injectable()
export class RentalObjectDocumentService extends ConnectedDocumentService<RentalObjectDocument> {
  constructor(client: HttpClient, messageService: MessageService, progressBar: ProgressBarService, @Inject(APP_CONFIG) config: IAppConfig) {
    super(client, messageService, progressBar, 'rental-object/documents', config);
  }

  createModel(): RentalObjectDocument {
    return new RentalObjectDocument();
  }
}
